<div class="relative">
	<button
		id="seleccionar-pasajero"
		(click)="togglePopup()"
		class="border-none rounded-none pt-4 flex items-center justify-between w-full bg-transparent text-black"
	>
		<span>{{ totalPassengers }} pasajero{{ totalPassengers !== 1 ? 's' : '' }}</span>
		<span class="material-icons">{{ isOpen ? 'expand_less' : 'expand_more' }}</span>
	</button>
	<div
		id="dropdownContent"
		[class.visible_]="isOpen"
		[class.hidden_]="!isOpen"
		class="absolute top-full left-0 mt-2 w-80 bg-white border border-gray-300 rounded-md shadow-lg p-4 transition-all"
	>
		<div *ngFor="let passengerType of passengerTypes" class="mb-4">
			<div class="flex items-center justify-between mb-2">
				<div class="flex items-center">
					<div class="ml-2">
						<div class="font-medium font-ubuntu text-black text-f18">{{ passengerType.label }}</div>
						<div class="font-normal font-ubuntu text-black text-f14">{{ passengerType.description }}</div>
					</div>
				</div>
				<div class="flex items-center">
					<button
						(click)="handlePassengerChange(passengerType.type, false)"
						[disabled]="passengers[passengerType.type] <= passengerType.min"
						class="bg-transparent text-black w-8 h-8 border-[2px] border-black rounded-full flex items-center justify-center font-ubuntu font-black text-f20"
					>
						<p class="relative mt-[-3px] text-black">-</p>
					</button>
					<span class="mx-0 w-6 text-center font-ubuntu font-medium text-f17">{{
						passengers[passengerType.type]
					}}</span>
					<button
						(click)="handlePassengerChange(passengerType.type, true)"
						[disabled]="passengers[passengerType.type] >= passengerType.max"
						class="bg-transparent text-black w-8 h-8 border-[2px] border-black rounded-full flex items-center justify-center font-ubuntu font-black text-f20"
					>
						<p class="relative mt-[-3px]">+</p>
					</button>
				</div>
			</div>
			@if(passengers.children > 0 && passengerType.type === 'children'){
			<div class="mt-4 px-3 py-2 bg-[#eeedf9d9] rounded-[21px] flex items-start">
				<img src="/images/icono-admiracion.png" class="mr-2" alt="Condiciones para el viaje." />
				<div class="text-black font-lato font-normal text-f14">
					Todo menor de edad hasta los 14 años debe viajar con un adulto responsable.
				</div>
			</div>
			}
			<div class="ml-2">
				@if(passengerType.type === 'infants' && passengers[passengerType.type] > 0){
				<p class="font-normal font-ubuntu text-black text-f14 flex items-start" style="line-height: 90%">
					<span><input type="checkbox" (change)="onQuieroAsiento($event)" /></span>
					<span class="pl-1">Quiero asiento</span>
				</p>
				}
			</div>
		</div>
		@if(passengers.infants > 0){
		<div class="mt-4 px-3 py-2 bg-[#eeedf9d9] rounded-[21px] flex items-start">
			<img src="/images/icono-admiracion.png" class="mr-2" alt="Condiciones para el viaje." />
			<div class="text-black font-lato font-normal text-f14">
				Un bebé ocupa el mismo asiento del adulto. Si necesitas un asiento adicional, indícalo en la casilla
				correspondiente.
			</div>
		</div>
		}
		<div class="mt-4 px-3 py-2 bg-[#909090] rounded-[21px] flex items-start">
			<img src="/images/icono-admiracion.png" class="mr-2" alt="Condiciones para el viaje." />
			<div class="text-white font-lato font-normal text-f14">
				<a href="/clausulas-de-viaje" target="_blank">Condiciones para el viaje.</a>
			</div>
		</div>
	</div>
</div>
<p-toast position="bottom-center" key="br" (onClose)="onReject()" />
